import { render, staticRenderFns } from "./PermissionedAutocomplete.vue?vue&type=template&id=1117b1ad"
import script from "./PermissionedAutocomplete.vue?vue&type=script&lang=js"
export * from "./PermissionedAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports